import { Typography, Button, Grid } from '@mui/material';

import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';
import { useUpdateModalStore } from '../../../zustandStore/store.update';
import { SourceActions } from './AttributesContent';

function AttributesHeader() {
  const store = useUpdateModalStore((state) => state);
  const user = {
    name: 'Attributes for Prizeet',
    avatar: '/static/images/avatars/1.jpg'
  };
  return (
    <Grid container justifyContent="space-between" alignItems="center">
      <Grid item>
        <Typography variant="h3" component="h3" gutterBottom>
          Attributes
        </Typography>
        <Typography variant="subtitle2">
          {user.name}, these are your recent attributes
        </Typography>
      </Grid>
      <Grid item>
        <Button
          sx={{ mt: { xs: 2, md: 0 } }}
          variant="contained"
          onClick={(e) =>
            store.actions.setModal({
              modalOpen: true,
              sourceAction: SourceActions.ATTRIBUTE_CREATE
            })
          }
          startIcon={<AddTwoToneIcon fontSize="small" />}
        >
          Create Attribute
        </Button>
      </Grid>
    </Grid>
  );
}

export default AttributesHeader;
